import { ataResolver, combineResolvers, get, heliumCommonResolver, resolveIndividual, } from "@helium/anchor-resolvers";
import { PublicKey } from "@solana/web3.js";
import * as anchor from "@coral-xyz/anchor";
import { getAssociatedTokenAddress, ASSOCIATED_TOKEN_PROGRAM_ID, getMint, TOKEN_2022_PROGRAM_ID, TOKEN_PROGRAM_ID, } from "@solana/spl-token";
const is2022 = async (provider, mint) => {
    try {
        const mintInfo = await getMint(provider.connection, mint, "confirmed", TOKEN_2022_PROGRAM_ID);
        return !!mintInfo;
    }
    catch (e) {
        return false;
    }
};
export function ataResolver2022({ instruction, account, mint, owner, }) {
    return resolveIndividual(async ({ path, accounts, idlIx, provider }) => {
        if ((typeof instruction === "undefined" || idlIx.name === instruction) &&
            path.join(".") === account) {
            const mintKey = get(accounts, mint.split("."));
            // @ts-ignore
            const ownerKey = owner
                ? get(accounts, owner.split("."))
                : provider.wallet?.publicKey;
            if (mintKey && ownerKey) {
                const is2022Mint = await is2022(provider, mintKey);
                const programId = is2022Mint ? TOKEN_2022_PROGRAM_ID : TOKEN_PROGRAM_ID;
                const t2022Addr = await getAssociatedTokenAddress(mintKey, ownerKey, true, programId, ASSOCIATED_TOKEN_PROGRAM_ID);
                return t2022Addr;
            }
        }
        return undefined;
    });
}
export const METADATA_PROGRAM_ID = new PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s");
export const MPL_DEFAULT_RULE_SET = new PublicKey("eBJLFYPxJmMGKuFwpDWkzxZeUrad92kZRC5BJLpzyT9");
const getMetadata = async (mint) => {
    return (await PublicKey.findProgramAddress([
        Buffer.from("metadata"),
        METADATA_PROGRAM_ID.toBuffer(),
        mint.toBuffer(),
    ], METADATA_PROGRAM_ID))[0];
};
const getMasterEdition = async (mint) => {
    return (await anchor.web3.PublicKey.findProgramAddress([
        Buffer.from("metadata"),
        METADATA_PROGRAM_ID.toBuffer(),
        mint.toBuffer(),
        Buffer.from("edition"),
    ], METADATA_PROGRAM_ID))[0];
};
const findTokenRecordPda = async (mint, token) => {
    return (await anchor.web3.PublicKey.findProgramAddress([
        Buffer.from("metadata"),
        METADATA_PROGRAM_ID.toBuffer(),
        mint.toBuffer(),
        Buffer.from("token_record"),
        token.toBuffer(),
    ], METADATA_PROGRAM_ID))[0];
};
export const is2022Token = async (provider, mint) => {
    try {
        const mintInfo = await getMint(provider.connection, mint, "confirmed", TOKEN_2022_PROGRAM_ID);
        return !!mintInfo;
    }
    catch (e) {
        return false;
    }
};
export const auctionManagerResolvers = combineResolvers(heliumCommonResolver, resolveIndividual(async ({ idlIx, path, provider, accounts, programId }) => {
    if (path[path.length - 1] == "metadata" && accounts.nft) {
        return PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            METADATA_PROGRAM_ID.toBuffer(),
            accounts.nft.toBuffer(),
        ], METADATA_PROGRAM_ID)[0];
    }
}), resolveIndividual(async ({ path, accounts, programId }) => {
    if (path[path.length - 1] == "nftEdition" && accounts.nft) {
        const nftEdition = await getMasterEdition(accounts.nft);
        return nftEdition;
    }
}), resolveIndividual(async ({ idlIx, path, accounts, programId }) => {
    if (path[path.length - 1] == "ownerTokenRecord" &&
        accounts.nft &&
        accounts.nftSource &&
        (idlIx.name === "listNftV0" ||
            idlIx.name === "stakeV0" ||
            idlIx.name === "unstakeV0")) {
        const tokenMintRecord = await findTokenRecordPda(accounts.nft, accounts.nftSource);
        return tokenMintRecord;
    }
}), resolveIndividual(async ({ idlIx, path, accounts, programId }) => {
    if (path[path.length - 1] == "ownerTokenRecord" &&
        accounts.nft &&
        accounts.nftEscrow &&
        (idlIx.name === "executeSaleV0" || idlIx.name === "closeAuctionV0")) {
        const tokenMintRecord = await findTokenRecordPda(accounts.nft, accounts.nftEscrow);
        return tokenMintRecord;
    }
}), resolveIndividual(async ({ idlIx, path, accounts, programId }) => {
    if (path[path.length - 1] == "destinationTokenRecord" &&
        accounts.nft &&
        accounts.nftEscrow &&
        idlIx.name === "listNftV0") {
        const tokenMintRecord = await findTokenRecordPda(accounts.nft, accounts.nftEscrow);
        return tokenMintRecord;
    }
}), resolveIndividual(async ({ idlIx, path, accounts, programId }) => {
    if (path[path.length - 1] == "destinationTokenRecord" &&
        accounts.nft &&
        accounts.nftRecipient &&
        (idlIx.name === "executeSaleV0" || idlIx.name === "closeAuctionV0")) {
        const tokenMintRecord = await findTokenRecordPda(accounts.nft, accounts.nftRecipient);
        return tokenMintRecord;
    }
}), resolveIndividual(async ({ path }) => {
    if (path[path.length - 1] == "authorizationRules") {
        return MPL_DEFAULT_RULE_SET;
    }
}), resolveIndividual(async ({ path }) => {
    if (path[path.length - 1] == "mplTokenAuthRulesProgram") {
        return new PublicKey("auth9SigNpDKz4sJJ1DfCTuZrZNSAgh9sFD3rboVmgg");
    }
}), resolveIndividual(async ({ idlIx, path, accounts, provider }) => {
    if (path[path.length - 1] == "tokenEscrowTokenProgram") {
        const mintKey = get(accounts, ["tokenMint"]);
        if (!mintKey) {
            throw new Error("No mint provided");
        }
        const is2022Mint = await is2022(provider, mintKey);
        return is2022Mint ? TOKEN_2022_PROGRAM_ID : TOKEN_PROGRAM_ID;
    }
}), ataResolver({
    instruction: "listNftV0",
    account: "nftSource",
    mint: "nft",
    owner: "listingAuthority",
}), ataResolver({
    instruction: "listNftV0",
    account: "nftEscrow",
    mint: "nft",
    owner: "auctionManager",
}), ataResolver2022({
    instruction: "placeBidV0",
    account: "tokenEscrow",
    mint: "tokenMint",
    owner: "auctionManager",
}), ataResolver2022({
    instruction: "placeBidV0",
    account: "tokenSource",
    mint: "tokenMint",
    owner: "payer",
}), ataResolver2022({
    instruction: "cancelBidV0",
    account: "tokenEscrow",
    mint: "tokenMint",
    owner: "auctionManager",
}), ataResolver2022({
    instruction: "cancelBidV0",
    account: "tokenSource",
    mint: "tokenMint",
    owner: "payer",
}), ataResolver({
    instruction: "executeSaleV0",
    account: "nftRecipient",
    mint: "nft",
    owner: "bidder",
}), ataResolver({
    instruction: "executeSaleV0",
    account: "nftEscrow",
    mint: "nft",
    owner: "auctionManager",
}), ataResolver2022({
    instruction: "executeSaleV0",
    account: "auctionProceedsTokenAccount",
    mint: "tokenMint",
    owner: "auctionProceedsWallet",
}), ataResolver2022({
    instruction: "executeSaleV0",
    account: "tokenEscrow",
    mint: "tokenMint",
    owner: "auctionManager",
}), ataResolver2022({
    instruction: "claimReferralRewardsV0",
    account: "tokenEscrow",
    mint: "tokenMint",
    owner: "auctionManager",
}), ataResolver2022({
    instruction: "claimReferralRewardsV0",
    account: "tokenSource",
    mint: "tokenMint",
    owner: "owner",
}), ataResolver({
    instruction: "claimReferralRewardsV0",
    account: "ownerTokenAccount",
    mint: "nft",
    owner: "owner",
}), ataResolver({
    instruction: "stakeV0",
    account: "nftSource",
    mint: "nft",
    owner: "owner",
}), ataResolver({
    instruction: "unstakeV0",
    account: "nftSource",
    mint: "nft",
    owner: "owner",
}), ataResolver({
    instruction: "claimStakeRewardsV0",
    account: "tokenSource",
    mint: "tokenMint",
    owner: "owner",
}), ataResolver({
    instruction: "claimStakeRewardsV0",
    account: "ownerTokenAccount",
    mint: "nft",
    owner: "owner",
}), ataResolver({
    instruction: "closeAuctionV0",
    account: "nftRecipient",
    mint: "nft",
    owner: "listingAuthority",
}), ataResolver({
    instruction: "closeAuctionV0",
    account: "nftEscrow",
    mint: "nft",
    owner: "auctionManager",
}), ataResolver2022({
    instruction: "closeAuctionV0",
    account: "tokenEscrow",
    mint: "tokenMint",
    owner: "auctionManager",
}), ataResolver({
    instruction: "claimFoundersV0",
    account: "tokenEscrow",
    mint: "tokenMint",
    owner: "foundersManager",
}), ataResolver({
    instruction: "claimFoundersV0",
    account: "tokenSource",
    mint: "tokenMint",
    owner: "payer",
}), ataResolver({
    instruction: "stakeFoundersV0",
    account: "tokenSource",
    mint: "tokenMint",
    owner: "payer",
}), ataResolver({
    instruction: "claimFoundersV0",
    account: "tokenEscrow",
    mint: "tokenMint",
    owner: "foundersManager",
}));
//# sourceMappingURL=resolvers.js.map